<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Motivo Cancelamento Marcação</h2>
                    </div>
                    <div class="menu-painel">
                        <button mat-stroked-button color="primary" (click)="add()" matTooltip="Criar">Novo
                        </button>
                    </div>
                </div>
                <div class="panel-body" (window:resize)="onResize($event)">
                    <div class="form-row">
                        <div class="form-group col-lg-6 col-md-7 col-sm-12 col-12">
                            <mat-form-field fxFlex="100%">
                                <input matInput type="text" (keyup)="doFilter($event)" placeholder="Filtrar">
                            </mat-form-field>
                        </div>
                    </div>
                    <table mat-table [dataSource]="dataSource" matSort class="table table-striped">
                        <ng-container matColumnDef="descricao">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Descrição </th>
                            <td mat-cell *matCellDef="let motivoCancelamento"> {{motivoCancelamento.descricao}} </td>
                        </ng-container>

                        <ng-container matColumnDef="details">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center"> Ações </th>
                            <td mat-cell *matCellDef="let motivoCancelamento" class="table-column-center">
                                <button mat-icon-button color="primary" (click)="details(motivoCancelamento)"
                                    matTooltip="Detalhar">
                                    <mat-icon class="mat-18">info</mat-icon>
                                </button>
                                <button mat-icon-button color="primary" (click)="update(motivoCancelamento)"
                                    matTooltip="Alterar">
                                    <mat-icon class="mat-18">edit</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" (click)="confirmDelete(motivoCancelamento.id)"
                                    matTooltip="Remover">
                                    <mat-icon class="mat-18">delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 30, 50, 70, 100]" showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>